<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 8.6898L6.01173 13.3327L14.6663 4.74437L12.5719 2.66602L6.01173 9.17597L3.42741 6.61144L1.33301 8.6898Z"
      fill="currentColor"
    />
  </svg>
</template>
